export default {
  common: {
    adminFunction: "Función de administrador",
    accountManagement: "Gestión de cuentas",
    accountPermission: "Gestión de cuentas y permisos",
    regionManagement: "Gestión de regiones",
    zoneCountryCity: "Actualizar zona, país y ciudad",
    cityWeatherManagement: "Datos del clima de la ciudad",
    weatherProfileBaseOnCity: "Actualizar perfil meteorológico basado en la ciudad",
    ecatDataManagement: "Gestión de datos de Catalog",
    ecatLibraryEquipmentsModels: "Equipos y modelos de la biblioteca Catalog",
    cancel: "Cancelar",
    save: "Guardar"
  },
  account: {
    inputUserName: "Ingrese el correo electrónico",
    thereAreNoMoreUsersLeft: "No quedan más usuarios.",
    superAdmin: "Súper Administrador",
    global: "Global",
    region: "Región",
    regional: "Regional",
    zoneCountry: "Zona/Pais",
    city: "Ciudad",
    segmentMegaCity: "Segmento (Mega ciudad)",
    status: "Estado",
    activeStatus: "Active status",
    role: "Rol",
    active: "Activo",
    inactive: "Inactivo",
    fillRole: "Por favor, elija un personaje"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/es.js